// extracted by mini-css-extract-plugin
export default {"menu":"applications-components-CustomStoreHeaderApp-custom-store-header-module__menu","hide-on-mobile":"applications-components-CustomStoreHeaderApp-custom-store-header-module__hide-on-mobile"};
    if(module.hot) {
      // 1782397803563
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  